export const ACTIONS = {
	CHANGE_CARD_NUMBER: 'change_card_number',
	CHANGE_CARD_HOLDER_NAME: 'change_card_holder_name',
	CHANGE_EXPIRE_DATE: 'change_expire_date',
	CHANGE_CVC: 'change_cvc',
	CHANGE_CURRENT_STEP: 'change_current_step',
	IS_MOBILE: 'is_mobile',
	SELECTED_INSTALLMENT: 'selected_installment',
	CHECKOUT_FORM_CONTENT: 'checkoutFormContent',
	IS_3D_PAYMENT: 'is_3d_payment',
	IS_PAYMENT_WITH_REGISTERED_CARD: 'is_payment_with_registered_card',
	IS_LOADER_ACTIVE: 'is_loader_active',
	STEPS_LOCKED: 'steps_locked',
	TOTAL_DEBT: 'total_debt',
	INITIAL_DATA: 'initial_data',
	RESULT_DATA: 'result_data',
	OVERVIEW: 'overview',
};

export const INPUT_SIZES = {
	BIG: 'big',
	SMALL: 'small'
};

export const INPUT_TYPES = {
	REGULAR: 'regular',
	CURRENCY: 'currency'
};

export const STEPS = {
	OVERVIEW: 0,
	PAYMENT: 1,
	RESULT: 2
};

export const SECTION_HEADERS = {
	PAYMENT_INFO: 'Ödeme bilgileri',
	PAYMENT_OPTIONS: 'Ödeme seçenekleri'
};

export const CUSTOM_PAYMENT_PROVIDER = 1;

export const KVKK_CONTENT = (
	<>
		<h3>KİŞİSEL VERİLERİN İŞLENMESİ HAKKINDA AYDINLATMA METNİ</h3>
		<p>
		<h3>1. Veri Sorumlusu</h3>

		Logo Yazılım San. Ve Tic. A.Ş. (“Logo” veya “Şirket”) olarak, kişisel verilerinizin korunmasına önem
		veriyoruz. Bu aydınlatma metni, ödeme yapılan süreçlerde kişisel verilerinizin ne şekilde işlendiği
		hakkında size bilgi vermek üzere hazırlanmıştır. Bu kapsamda Logo, veri sorumlusu olarak hareket
		etmektedir.

		<h3>2. Kişisel Verilerinizi İşleme Amaçlarımız ve Hukuki Sebepleri</h3>
		
		< a href="https://www.mevzuat.gov.tr/mevzuat?MevzuatNo=6698&MevzuatTur=1&MevzuatTertip=5" target={"_blank"}>Kişisel Verilerin Korunması Kanunu’nun</a> (“Kanun”) 
		5. ve 6. maddeleri, kişisel veri işlemenin hukuki sebeplerini düzenlemektedir. Ödeme yaptığınız süreçlerde, 
		kişisel verilerinizin hangi amaçlar ve hukuki sebeplerle işlendiğini aşağıda bulabilirsiniz:<br/>
		
		<br/>Kişisel verileriniz, bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla,
		sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli olması hukuki sebebine dayalı olarak
		aşağıdaki amaçlarla işlenmektedir:<br/>

		<br/>− Ödemenin yapılabilmeniz için, ilgili ödeme ekranına yönlendirme yapılması.<br/>
		<br/>− Satın alma işleminin gerçekleştirilmesi, satış işlemine ilişkin ödemelerin alınması ve fatura
		düzenlenmesi.<br/>
		<br/>− Oluşturulan tahsilat makbuzu ve ilgili belgelerinin tarafınıza iletilmesi.<br/>
		<br/>− Ödeme ve iade işlemlerinin gerçekleştirilebilmesi amacıyla kart bilgilerinin ödeme ve kart
		saklama kuruluşları ile bankalar ile paylaşılması.<br/>

		<br/>Kişisel verileriniz, hukuki yükümlülüklerimizin yerine getirilmesi hukuki sebebine dayalı olarak aşağıdaki
		amaçla işlenmektedir:<br/>

		<br/>− Yetkili kurum veya kuruluşların Şirketimizden talepte bulunması ya da bu kurumlara bildirim
		yapmamızın öngörüldüğü durumlarda, yasal yükümlülüklerimizin yerine getirilmesi (örneğin,
		hukuka aykırı işlem şüphesi taşıyan bir işleme dair bir kamu kurumunun talepte bulunması
		durumunda bilgilerinizin paylaşılması).<br/>
		<br/>Kişisel verileriniz, veri işlemenin bir hakkın tesisi, kullanılması veya korunması zorunlu olması hukuki
		sebebine dayalı olarak aşağıdaki amaçla işlenmektedir:<br/>
		<br/>− Olası bir uyuşmazlık durumunda haklarımızın korunabilmesi ve kullanılması ile hukuki
		süreçlerin yürütülmesi.<br/>

		<br/>Kişisel verileriniz, ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun
		meşru menfaatleri için veri işlenmesinin zorunlu olması hukuki sebebine dayalı olarak aşağıdaki
		amaçlarla işlenmektedir:<br/>

		<br/>− Finans ve muhasebe işlemlerinin gerçekleştirilmesi.<br/>
		<br/>− İş faaliyetleirimizin iyileştirilmesi ve geliştirilmesi

		<h3>3. İşlenen Kişisel Verileriniz</h3>
		
		Bu aydınlatma metninde belirtilen amaçlar ve hukuki sebepler kapsamında; kimlik, iletişim, finans ve
		ödeme bilgilerinize ilişkin kişisel verileriniz işlenmektedir. Ayrıca IP adresi ve kullanıcı işlem güvenliğine
		kayıtlarınıza ilişkin işlem güvenliği verileriniz de işlenmektedir.<br/>

		<h3>4. Kişisel Verilerinizin Kimlere ve Hangi Amaçlarla Aktarılacağı</h3>
		
		Kişisel verilerinizi üçüncü taraflara aktarırken Kanun’un 8. maddesinde belirtilen kurallara uygunluk
		sağlanmaktadır. Kişisel verileriniz aşağıda yer alan yurt içindeki taraflara, belirtilen amaçlarla aktarılır:<br/>
		
		<br/>− Yetkili Kişi, Kurum ya da Kuruluşlar: Yetkili kurum veya kuruluşların Şirketimizden talepte
		bulunması ya da bu kurumlara bildirim yapmamızın öngörüldüğü durumlarda, yasal
		yükümlülüklerimizin yerine getirilmesi. Şirketimizden suç gelirlerinin önlenmesine ilişkin
		mevzuat gereğince bilgi ve belge paylaşım talebinde bulunulması.<br/>

		<br/>− Hizmet Aldığımız Şirketler: Ödeme, tahsilat ve iade işlemlerinin yapılabilmesi amacıyla bu
		kapsamda destek aldığımız ödeme ve kart saklama kuruluşları ile bankalar.<br/>
		
		<br/>− Adli ve İdari Makamlar: Adli ve idari takip işlemlerinin ve uyuşmazlık çözümlerinin yerine
		getirilmesi.<br/>

		<h3>5. Kişisel Veri Toplama Yöntemlerimiz ve Hukuki Sebepleri</h3>
		
		Kişisel verileriniz tahsilat ürünümüz üzerinden ödeme ekranında bilgilerinizi doldurmanız suretiyle elde
		edilmektedir. Kişisel verileriniz, tahsilat ürünümüz üzerinden otomatik ve kısmen otomatik yöntemler
		ile toplanmaktadır.<br/>

		<br/>Kişisel verilerinizi, bir sözleşmenin kurulması veya ifası için kişisel verilerin işlenmesinin gerekli olması,
		hukuki yükümlülüklerimizin yerine getirilmesi, bir hakkın tesisi, kullanılması veya korunması ve ilgili
		kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri
		için veri işlenmesinin zorunlu olması hukuki sebeplerine dayalı olarak işliyoruz.<br/>

		<h3>6. Veri Sahibi Olarak Haklarınız Nelerdir?</h3>

		Kanun’un 11. maddesi uyarınca, kişisel verilerinize ilişkin olarak aşağıdaki haklara sahipsiniz:<br/>

		<br/>− Kişisel veri işlenip işlenmediğini öğrenme,<br/>
		<br/>− Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,<br/>
		<br/>− Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını<br/>
		öğrenme,
		<br/>− Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,<br/>
		<br/>− Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,<br/>
		<br/>− Kişisel verilerin silinmesini veya yok edilmesini isteme,<br/>
		<br/>− Kişisel verilerin düzeltilmesi, silinmesi ya da yok edilmesi halinde bu işlemlerin kişisel verilerin
		aktarıldığı üçüncü kişilere bildirilmesini isteme,<br/>
		<br/>− İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin
		kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,<br/>
		<br/>− Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğranması hâlinde zararın
		giderilmesini talep etme.<br/>

		<br/><b>Haklarınızı kullanmak için:</b> Lütfen taleplerinizi içerir dilekçenizi aşağıdaki adrese posta yolu ile ya da
		daha önce bize bildirmiş olduğunuz e-posta adresiniz üzerinden <a href="mailto:kvkk@logo.com.tr" >kvkk@logo.com.tr</a> e-posta adresine
		gönderiniz.<br/>
		
		<br/>Haklarınızı kullanmak için ayrıca <a href="https://www.mevzuat.gov.tr/mevzuat?MevzuatNo=24455&MevzuatTur=9&MevzuatTertip=5" target={"_blank"}>Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında
		Tebliğ’de</a> belirtilen yöntemleri de tercih edebilirsiniz. Talebiniz en kısa sürede ve en geç otuz gün
		içerisinde yanıtlanacaktır.<br/>
		
		<br/>Adres: Gebze Organize Sanayi Bölgesi, Şahabettin Bilgisu Cad. No:609 Gebze/Kocaeli
		</p>
	</>
);
